import { Breadcrumb, Button, Col, Drawer, Empty, Flex, Form, Grid, Input, Popconfirm, Row, Table, Tag, Tooltip, Typography, notification, theme } from 'antd';
import { FilterOutlined, UnlockOutlined, LockOutlined, HomeOutlined, DeleteOutlined, EyeOutlined, EditOutlined, WarningOutlined } from '@ant-design/icons';
import React, { useEffect, useState, useCallback } from 'react'
import RawData from './Data';
import Permission from './Permission';
import { useSelector } from 'react-redux';
import MasterDataAPI from '../../restAPI/MasterDataAPI';
import FilterComponent from '../../utils/FilterComponent';
import CommonSkeletonLoader from '../../helperComponents/CommonSkeleton';

const { Search } = Input;
const { Text, Link } = Typography;
const { useBreakpoint } = Grid;

export default function Role() {
    const { companyId, token, role } = useSelector(state => state.auth);
    const [form] = Form.useForm();
    const formValues = Form.useWatch([], form);
    const [roleId, setRoleId] = useState("");
    const [actionState, setActionState] = useState('add')
    const [searchInputValue, setSearchInputValue] = useState("");
    const [roleData, setRoleData] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [initialRoleData, setInitialRoleData] = useState({ 
        name: "", 
        description: "" 
    });
    const [initialPermissions, setInitialPermissions] = useState([]);
    const [viewData, setViewData] = useState({
        name: "",
        description: "",
        status: null,
    });
    const [tempRoleData, setTempRoleData] = useState([]);
    const [filterValues, setFilterValues] = useState([]);
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false); // New state for view drawer
    const [openFIlter, setOpenFilter] = useState(false);
    const [showPopconfirm, setShowPopconfirm] = useState(false);
    const [cancelButtonDisabled, setCancelButtonDisabled] = useState(false);
    const [isRoleListLoading, setIsRoleListLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [loading, setLoading] = useState(false);

    const [api, contextHolder] = notification.useNotification();
    const [btnPermission, setBtnPermission] = useState({
        "add": false,
        "edit": false,
        "delete": false,
        "view": false,
        "activeInactive": false
    });

    const showFilterDrawer = () => {
        setOpenFilter(true);
    }
    const onCloseFilter = () => {
        setOpenFilter(false);
    }

    const showDrawer = () => {
        form.resetFields();
        setInitialRoleData({ 
            name: "", 
            description: "" 
        });
        setInitialPermissions([]);
        setPermissions([]);
        setActionState('add');
        setOpen(true);
    };

    const showDrawer2 = () => {
        setOpen2(true);
    };

    const onClose = () => {
        form.resetFields();
        setInitialRoleData({ 
            name: "", 
            description: "" 
        });
        setInitialPermissions([]);
        setOpen(false);
        getRoleData(false, roleId);
        setPermissions([]);
        // setFilterValues([]);
        // setSearchInputValue("");
        setShowPopconfirm(false);
        setRoleId("");
        setTimeout(() => {
            setActionState('add')
        }, 200)
    };

    const onClose2 = () => {
        setOpen2(false);
        setViewData({
            name: "",
            description: "",
            status: null,
        });
        setPermissions([]);
    };

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const editHandler = (records) => {
        const initialValues = {
            name: records.name,
            description: records.description || "",
        };
        setRoleId(records.id);
        setInitialRoleData(initialValues);
        const recordPermissions = records?.permissionLevel || [];
        setInitialPermissions(JSON.parse(JSON.stringify(recordPermissions)));
        setPermissions(recordPermissions);
        form.setFieldsValue(initialValues);
        setActionState("edit")
        setOpen(true);
    }

    const viewHandler = (records) => {
        setRoleId(records.id);
        setViewData({
            name: records.name,
            description: records.description || "",
            status: records.status,
        });
        setPermissions(records?.permissionLevel || []);
        showDrawer2();
    }

    const openNotificationWithIcon = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };

    const columns = [
        {
            title: 'Role ID',
            dataIndex: 'roleId',
            key: 'roleId',
            render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
        },
        {
            title: 'Role Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            fixed: 'right',
            render: (_, record) => (
                record.status ? (<Tag color='purple' style={{ width: 90, textAlign: 'center' }}>Active</Tag>) : (<Tag color='warning' style={{ width: 90, textAlign: 'center' }}>Inactive</Tag>)
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            fixed: 'right',
            render: (_, record) => (
                <Flex gap="small" justify="center" align="center" vertical>
                    <Flex gap="middle" wrap="wrap">
                        {btnPermission.edit &&
                            <Tooltip title="Edit Role" placement="top">
                                <Button
                                    disabled={(record?.restricted === true || !record.status)}
                                    type="primary"
                                    icon={<EditOutlined />}
                                    size='small'
                                    onClick={() => editHandler(record)}
                                />
                            </Tooltip>
                        }
                        {btnPermission.view &&
                            <Tooltip title="View Role" placement="top">
                                <Button icon={<EyeOutlined />} size='small' onClick={() => viewHandler(record)} />
                            </Tooltip>
                        }
                        {
                            btnPermission.activeInactive && (
                                <Tooltip title="Active/Inactive Role" placement="top">
                                    <Popconfirm
                                        title={record.status ? "Do you want to inactivate the role?" : "Do you want to reactivate the role?"}
                                        onConfirm={() => editStatusHandler(record)}
                                        onCancel={() => openNotificationWithIcon('error', 'Abort', `Status update cancelled`, 'bottomLeft')}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <Button
                                            icon={record.status ? <LockOutlined /> : <UnlockOutlined />}
                                            size='small'
                                            disabled={record?.restricted === true}
                                        />
                                    </Popconfirm>
                                </Tooltip>
                            )
                        }
                        {btnPermission.delete && (
                            <Tooltip title="Delete Role" placement="top">
                                <Popconfirm
                                    title="Do you want to delete this role?"
                                    onConfirm={() => deleteHandler(record)}
                                    onCancel={() => openNotificationWithIcon('error', 'Abort', `Delete cancelled`, 'bottomLeft')}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button danger type="primary" disabled={record.status} icon={<DeleteOutlined />} size='small' />
                                </Popconfirm>
                            </Tooltip>
                        )}
                    </Flex>
                </Flex>
            ),
        },
    ];

    const screens = useBreakpoint();


    const applySearchAndFilters = (data, searchText, filters) => {
        return data.filter((role) => {
            const matchesSearch = searchText ? 
                (role.name || '').toLowerCase().includes(searchText.toLowerCase()) ||
                (role.description || '').toLowerCase().includes(searchText.toLowerCase()) 
                : true

            const matchesFilters = filters.length > 0 ?
                filters.every(({ key, value }) => {
                    if (!value) return false;
                    const itemValue = role[key]?.toString().toLowerCase() || '';
                    return itemValue.startsWith(value.toLowerCase());
                })
                : true

            return matchesSearch && matchesFilters
        })
    }


    const getRoleNameRules = useCallback(() => [
        { required: true, message: 'Role name is required' },
        { max: 50, message: 'Role name must be less than 50 characters' },
        {
            validator: (_, value) => {
                if (value && value.trim().length === 0) {
                    return Promise.reject(new Error('Role Name is not valid.'));
                }
                return Promise.resolve();
            }
        }
    ], []);

    const getRoleDescriptionRules = useCallback(() => [
        { max: 250, message: 'Role description must be less than 250 characters' }
    ], []);

    const isFormModified = useCallback(() => {
        if (!formValues) return false;
        
        const currentName = (formValues.name || "").trim();
        const currentDescription = (formValues.description || "").trim();
        const initialName = (initialRoleData.name || "").trim();
        const initialDescription = (initialRoleData.description || "").trim();

        const formChanged = currentName !== initialName || currentDescription !== initialDescription;
                
        const filteredCurrentPermissions = permissions.filter(p => p.permissionLevel.length > 0);
        const filteredInitialPermissions = initialPermissions.filter(p => p.permissionLevel.length > 0);
        
        const permissionsChanged = JSON.stringify(filteredCurrentPermissions) !== JSON.stringify(filteredInitialPermissions);

        return formChanged || permissionsChanged;
    }, [formValues, initialRoleData, permissions, initialPermissions]);

    const getRoleData = async (isFirstTime = true, roleId = "") => {
        try{
            const {data} = await MasterDataAPI.getRoleDataByCompanyId(companyId,token);
            if(!isFirstTime){
                setRoleData(data);
                const updatedTempList = applySearchAndFilters(data, searchInputValue, filterValues);
                setTempRoleData(updatedTempList);
            }else{
                setRoleData(data);
                setTempRoleData(data);                
            }            
        }catch(error){
            console.log('error fetching role data : ',error);
        }finally{
            setIsRoleListLoading(false)
        }
        
    }

    useEffect(() => {
        setIsRoleListLoading(true);
        getRoleData();
    }, [companyId]);

    const validateBeforeSubmit = async () => {
        try {
            await form.validateFields();
            return true;
        } catch (errorInfo) {
            return false;
        }
    }

    const handleSubmit = async () => {
        const validation = await validateBeforeSubmit();
        if (!validation) {
            return;
        }

        setLoading(true);
        const formValues = form.getFieldsValue();
        const filteredPermissions = permissions.filter(permission => permission.permissionLevel.length > 0);
        
        const trimmedPayload = {
            name: (formValues.name || "").trim(),
            description: (formValues.description || "").trim() || null,
            permissionLevel: filteredPermissions
        };

        if (actionState === "add") {
            try {
                const { message } = await MasterDataAPI.createRole(trimmedPayload, companyId, token);
                openNotificationWithIcon('success', 'Successful', `${message}`, 'bottomLeft');
                onClose();
            } catch (error) {
                if (error.response) {
                    openNotificationWithIcon('error', 'Role creation failed', `${error.response.data.message}`, 'bottomLeft');
                } else {
                    openNotificationWithIcon('error', 'Role creation failed', `${error.message}`, 'bottomLeft');
                }
            } finally {
                setShowPopconfirm(false);
                setLoading(false);
            }
        }

        if (actionState === "edit") {
            try {
                const { message } = await MasterDataAPI.updateRole(roleId, trimmedPayload, companyId, token);
                openNotificationWithIcon('success', 'Successful', `${message}`, 'bottomLeft');
                onClose();
            } catch (error) {
                if (error.response) {
                    openNotificationWithIcon('error', 'Role update failed', `${error.response.data.message}`, 'bottomLeft');
                } else {
                    openNotificationWithIcon('error', 'Role update failed', `${error.message}`, 'bottomLeft');
                }
            } finally {
                setShowPopconfirm(false);
                setLoading(false);
            }
        }
    }

    const handleCreateUpdateClick = async (e) => {
        e.preventDefault();
        let validation = await validateBeforeSubmit();
        if (actionState === "add" && validation) {
            handleSubmit();
        }
        else {
            if (validation) {
                setShowPopconfirm(true)
            } else {
                setShowPopconfirm(false)
            }
        }
    }

    const handleCancel = () => {
        setCancelButtonDisabled(true);
        openNotificationWithIcon('error', 'Abort', `${actionState === "add" ? "Create" : "Update"} cancelled`, 'bottomLeft');
        setTimeout(() => {
            setShowPopconfirm(false);
            setCancelButtonDisabled(false);
        }, 300);
    };

    const editStatusHandler = async (records) => {
        try{            
                const {message} = await MasterDataAPI.updateStatusRole(records.id, {
                    status: !records.status,
                }, companyId, token);
                openNotificationWithIcon('success', 'Successful', `${message}`, 'bottomLeft');
                getRoleData(false, records.id);
        }catch(error){
            if (error.response) {
                openNotificationWithIcon('error', 'Role status change failed', `${error.response.data.message}`, 'bottomLeft');
            } else {
                openNotificationWithIcon('error', 'Role status change failed', `${error.message}`, 'bottomLeft');
            }
        }        
    }

    const deleteHandler = async (records) => {
        try{
            const {message} = await MasterDataAPI.deleteRole(records.id, companyId, token);
            openNotificationWithIcon('success', 'Successful', `${message}`, 'bottomLeft');
            getRoleData(false, records.id);
        }catch(error){
            if (error.response) {
                openNotificationWithIcon('error', 'Role deletion failed', `${error.response.data.message}`, 'bottomLeft');
            } else {
                openNotificationWithIcon('error', 'Role deletion failed', `${error.message}`, 'bottomLeft');
            }
        }        
    }


    const handleCheckboxChange = (roleName, permissionType, checked) => {
        setPermissions(prevPermissions => {
            const updatedPermissions = [...prevPermissions];
            const roleIndex = updatedPermissions.findIndex(role => role.permissionName === roleName);

            if (roleIndex === -1) {
                updatedPermissions.push({
                    permissionName: roleName,
                    permissionLevel: checked ? [permissionType] : []
                });
            } else {
                let currentLevels = updatedPermissions[roleIndex].permissionLevel;

                if (typeof currentLevels === 'string') {
                    try {
                        currentLevels = JSON.parse(currentLevels);
                    } catch {
                        currentLevels = [];
                    }
                }

                if (checked) {
                    if (!currentLevels.includes(permissionType)) {
                        currentLevels.push(permissionType);
                    }
                } else {
                    currentLevels = currentLevels.filter(type => type !== permissionType);
                }

                updatedPermissions[roleIndex].permissionLevel = [...new Set(currentLevels)];
            }

            return updatedPermissions;
        });
    };

    const filterDataByCriteria = (data, criteria) => {
        return data.filter(item => {
            return criteria.every(({ key, value }) => {
                if (!item[key] || !value) return false;
                const itemValue = (item[key]?.toString() || '').toLowerCase();
                const lowerCasePrefix = (value || '').toLowerCase();
                return itemValue.includes(lowerCasePrefix);
            });
        });
    }

    const handleFilterDetailsChange = (value) => {
        setFilterValues(value);
    }

    const handleSearchFunction = (value) => {
        setSearchInputValue(value);
        if (value) {
            if (filterValues.length > 0) {
                const filterData = tempRoleData.filter(item =>
                    (item.name || '').toLowerCase().includes(value.toLowerCase()) ||
                    (item.description || '').toLowerCase().includes(value.toLowerCase())
                )
                setTempRoleData(filterData);
            } else {
                const filterData = roleData.filter(item =>
                    (item.name || '').toLowerCase().includes(value.toLowerCase()) ||
                    (item.description || '').toLowerCase().includes(value.toLowerCase())
                )
                setTempRoleData(filterData);
            }
        } else {
            if (filterValues.length > 0) {
                const filterData = filterDataByCriteria(roleData, filterValues);
                setTempRoleData(filterData);
            } else {
                setTempRoleData(roleData)
            }
        }
    }

    const handleFilterSearchFunction = (values) => {
        if (values) {
            if (searchInputValue.length > 0) {
                const filteredData = roleData.filter(item =>
                    (item.name || '').toLowerCase().includes(searchInputValue.toLowerCase()) ||
                    (item.description || '').toLowerCase().includes(searchInputValue.toLowerCase())
                );
                const filterData2 = filterDataByCriteria(filteredData, values);
                setTempRoleData(filterData2);
            } else {
                const filterData = filterDataByCriteria(roleData, values);
                setTempRoleData(filterData);
            }
        } else {
            if (searchInputValue.length > 0) {
                const filteredData = roleData.filter(item =>
                    (item.name || '').toLowerCase().includes(searchInputValue.toLowerCase()) ||
                    (item.description || '').toLowerCase().includes(searchInputValue.toLowerCase())
                );
                setTempRoleData(filteredData);
            } else {
                setTempRoleData(roleData)
            }
        }
    }

    const handleRemoveTag = (key) => {
        setFilterValues(prev =>
            prev.filter(item => item.key !== key)
        );
    }

    useEffect(() => {
        handleFilterSearchFunction(filterValues)
        setCurrentPage(1); // Reset to page 1 when filters change
    }, [filterValues])

    useEffect(() => {
        handleSearchFunction(searchInputValue)
        setCurrentPage(1); // Reset to page 1 when search changes
    }, [searchInputValue])

    useEffect(() => {
        setBtnPermission({
            "add": false,
            "edit": false,
            "delete": false,
            "view": false,
            "activeInactive": false
        })
        if (role.length > 0) {
            role.forEach(value => {
                if (value.restricted) {
                    if (value.roleName === "Company Admin") {
                        setBtnPermission({
                            "add": true,
                            "edit": true,
                            "delete": true,
                            "view": true,
                            "activeInactive": true
                        })
                    } else if (value.roleName === "Admin") {
                        setBtnPermission({
                            "add": true,
                            "edit": true,
                            "delete": true,
                            "view": true,
                            "activeInactive": true
                        })
                    }
                } else if (value?.permissions) {
                    const permissionData = value.permissions.find(data => data.permissionName === "Role");
                    if (permissionData) {
                        permissionData.permissionLevel.map(value => {
                            switch (value) {
                                case "create":
                                    setBtnPermission(prevState => ({
                                        ...prevState,
                                        add: true
                                    }));
                                    break;
                                case "view":
                                    setBtnPermission(prevState => ({
                                        ...prevState,
                                        view: true
                                    }));
                                    break;
                                case "edit":
                                    setBtnPermission(prevState => ({
                                        ...prevState,
                                        edit: true
                                    }));
                                    break;
                                case "delete":
                                    setBtnPermission(prevState => ({
                                        ...prevState,
                                        delete: true
                                    }));
                                    break;
                                case "Active / Inactive":
                                    setBtnPermission(prevState => ({
                                        ...prevState,
                                        activeInactive: true
                                    }));
                                    break;
                            }
                        })
                    } else {
                        setBtnPermission({
                            "add": false,
                            "edit": false,
                            "delete": false,
                            "view": false,
                            "activeInactive": false
                        })
                    }
                }
            });
        }
    }, []);

    const filterTags = filterValues.filter(filterObject => filterObject.value.trim() !== "");

    return (
        <>
            <Flex gap={20} justify='space-between' align='center' style={{
                margin: '16px',
                padding: '16px 24px',
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Breadcrumb
                    items={[
                        {
                            title: <HomeOutlined />,
                        },
                        {
                            title: 'Master Data / Role',
                        },
                    ]}
                />
                <Flex justify='center' align='center' gap={12}>
                    <Flex justify='center' align='center' gap={12}>
                        {btnPermission.view && (
                            <>
                                <Button
                                    onClick={showFilterDrawer}
                                    icon={<FilterOutlined style={{ paddingLeft: 8, paddingRight: 8 }} />}
                                />
                                <Search
                                    placeholder="Search"
                                    value={searchInputValue}
                                    onChange={(e) => setSearchInputValue(e.target.value)}
                                />
                            </>
                        )}
                    </Flex>
                    {btnPermission.add && (
                        <Button type="primary" onClick={showDrawer}>Add New</Button>
                    )}
                </Flex>
            </Flex>
            <div style={{ margin: '16px' }}>
                {filterTags.length !== 0 &&
                    <Flex align='center' gap={12}>
                        {filterTags.map(item => (
                            <Tag
                                bordered={false}
                                closable
                                color='success'
                                key={item?.key}
                                onClose={() => handleRemoveTag(item?.key)}
                            >
                                {item?.value}
                            </Tag>
                        ))}
                    </Flex>
                }
            </div>
            <div style={{
                margin: '16px',
                padding: 24,
                minHeight: "78svh",
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                {isRoleListLoading ? (<>
                    <CommonSkeletonLoader />
                </>) : (<>
                    <Table
                        columns={columns}
                        dataSource={tempRoleData}
                        scroll={{ x: 'max-content' }}
                        pagination={{
                            current: currentPage,
                            pageSize,
                            onChange: (page, size) => {
                                setCurrentPage(page);
                                setPageSize(size);
                            },
                            onShowSizeChange: (current, size) => {
                                setCurrentPage(1);
                                setPageSize(size);
                            },
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '50', '100'],
                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                            selectProps: {
                                showSearch: false,
                                inputReadOnly: true,
                                onInputKeyDown: (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                },
                                onKeyDown: (e) => {
                                    // Allow only arrow keys, Enter, Escape, Tab
                                    if (!['ArrowUp', 'ArrowDown', 'Enter', 'Escape', 'Tab'].includes(e.key)) {
                                        e.preventDefault();
                                    }
                                }
                            }
                        }}
                    />
                </>)}
                <Drawer title={actionState === 'add' ? "Add Role" : "Update Role"}
                    onClose={onClose}
                    open={open}
                    size='large'
                    width={screens.md ? "calc( 100% - 180px)" : null}
                    footer={[
                        <Flex justify='flex-end' align='center' gap='large' key="footer-buttons">
                            <Button onClick={onClose}>
                                Cancel
                            </Button>
                            {actionState === 'add' ? (
                                <Button type="primary" onClick={handleSubmit} loading={loading}>
                                    Create
                                </Button>
                            ) : (
                                <Popconfirm
                                    title="Do you want to update the Role?"
                                    open={showPopconfirm}
                                    onConfirm={() => handleSubmit()}
                                    onCancel={handleCancel}
                                    okText="Yes"
                                    cancelText="No"
                                    cancelButtonProps={{ disabled: cancelButtonDisabled }}
                                >
                                    <Button 
                                        type="primary" 
                                        onClick={handleCreateUpdateClick}
                                        disabled={!isFormModified()}
                                        loading={loading}
                                    >
                                        Update
                                    </Button>
                                </Popconfirm>
                            )}
                        </Flex>
                    ]}
                >
                    <Form 
                        form={form}
                        layout="vertical"
                        initialValues={{
                            name: "",
                            description: "",
                        }}
                    >
                        <Row gutter={12}>
                            <Col span={24}>
                                <Form.Item
                                    label="Role Name"
                                    name="name"
                                    rules={getRoleNameRules()}
                                    required
                                >
                                    <Input
                                        placeholder="Name"
                                        autoComplete="new-name"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Form.Item
                                    label="Role Description"
                                    name="description"
                                    rules={getRoleDescriptionRules()}
                                >
                                    <Input.TextArea
                                        placeholder='Description'
                                        autoComplete='new-description'
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    <Permission parentData={permissions} rawData={RawData} childData={handleCheckboxChange} status={false} />
                </Drawer>

                {/* View Drawer */}
                <Drawer
                    title="View Role"
                    onClose={onClose2}
                    open={open2}
                    size='large'
                    width={screens.md ? "calc( 100% - 180px)" : null}
                // footer={[
                //     <Flex justify='flex-end' align='center'>
                //         <Button onClick={onClose2}>
                //             Close
                //         </Button>
                //     </Flex>
                // ]}
                >
                    <Row gutter={[16, 16]}>
                        <Col span={12}>
                            <Text type="secondary">Role Name</Text>
                            <div><Text strong>{viewData.name}</Text></div>
                        </Col>
                        <Col span={12}>
                            <Text type="secondary">Status</Text>
                            <div style={{ marginTop: 8 }}>
                                {viewData.status ? (
                                    <Tag color="purple" style={{ width: 90, textAlign: "center" }}>
                                        Active
                                    </Tag>
                                ) : (
                                    <Tag color="warning" style={{ width: 90, textAlign: "center" }}>
                                        Inactive
                                    </Tag>
                                )}
                            </div>
                        </Col>
                        <Col span={24}>
                            <Text type="secondary">Description</Text>
                            <div><Text strong>{viewData.description || "N/A"}</Text></div>
                        </Col>
                    </Row>
                    <br />
                    <Permission parentData={permissions} rawData={RawData} childData={handleCheckboxChange} status={true} />
                </Drawer>

                <FilterComponent
                    openDrawer={openFIlter}
                    closeDrawer={onCloseFilter}
                    data={tempRoleData}
                    handleFilterDetailsChange={handleFilterDetailsChange}
                    filterValues={filterValues}
                    screenName="masterData_role"
                    resetFilterValues={() => setFilterValues([])}
                />
                {contextHolder}
            </div>
        </>
    )
}